"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedDescription = exports.splitByNewLine = exports.getNumberWithLeadZero = exports.replaceAll = exports.truncateTextByMiddle = void 0;
function truncateTextByMiddle(text, maxLength) {
    if (text.length > maxLength) {
        const half = Math.floor((maxLength - 3) / 2);
        return `${text.substr(0, half)}...${text.substr(text.length - half)}`;
    }
    return text;
}
exports.truncateTextByMiddle = truncateTextByMiddle;
function replaceAll(target, search, replacement) {
    return target === null || target === void 0 ? void 0 : target.replace(new RegExp(search, 'g'), replacement);
}
exports.replaceAll = replaceAll;
function getNumberWithLeadZero(value, digits = 2) {
    const zeros = new Array(digits - 1).fill(0).join('');
    return `${zeros}${value.toString()}`.slice(-digits);
}
exports.getNumberWithLeadZero = getNumberWithLeadZero;
function splitByNewLine(string) {
    return string.split(/(\r|\n)+/).filter(item => item.trim());
}
exports.splitByNewLine = splitByNewLine;
function formattedDescription(source) {
    if (!source || source.length === 0) {
        return '';
    }
    let description;
    try {
        description = JSON.parse(source);
    }
    catch (e) {
        return source.replace(/(\r\n|\n|\r)/g, '<br/>');
    }
    let str = '';
    // show tags if there are more than one
    let showTags = description.length > 1;
    description.forEach(function (paragraph) {
        if (showTags && paragraph.name && paragraph.name.length > 0) {
            let name = paragraph.name.replace(/(\r\n|\n|\r)/g, '<br/>');
            str += '<h3>' + name + '</h3>';
        }
        if (paragraph.text && paragraph.text.length > 0) {
            let text = paragraph.text.replace(/(\r\n|\n|\r)/g, '<br/>');
            str += '<span>' + text + '</span>';
        }
    });
    return str;
}
exports.formattedDescription = formattedDescription;
